/**
 * @file: copy 复制列表排序
 * @author: xiaolong.huang@dmall.com
 */

import * as CubeTree from '../../cubeTree/index';
import * as UIToolkit from '../../UIToolkit';
import CodiSystem from '../../codiSystem/index';
import Utils from '../../utils/util';

/**
 * 1. 货架、商品、隔板、文本框 按视图坐标从左到右排
 * 2. 层板按posY从上到下的顺序排列
 */
function sortCopyList(copyCubeList: Array<CubeId>): Array<CubeId> {
    let result: Array<CubeId> = [];
    let temp: Array<FreeObjMap> = [];
    let group: Array<Array<FreeObjMap>> = [];
    let layersCube: Array<FreeObjMap> = [];
    let layersCubeList: CubeId[] = [];
    let layers: Array<FreeObjMap> = [];
    let shelfs: Array<FreeObjMap> = [];

    copyCubeList.forEach((cubeId: CubeId): void => {
        if (CubeTree.isGoods(cubeId)
            || CubeTree.isBafflePlate(cubeId)
            || CubeTree.isTextarea(cubeId)) {
            layersCubeList.push(cubeId);
        }
        else if (CubeTree.isPartition(cubeId)) {
            layers.push({
                id: cubeId,
                top: CodiSystem.getLogicCoordinate(cubeId).top
            });
        }
        else if (CubeTree.isShelf(cubeId) || CubeTree.isFreezer(cubeId)) {
            shelfs.push({
                id: cubeId,
                left: CodiSystem.getLogicCoordinate(cubeId).left
            });
        }
    });

    // 商品、隔板、文本框
    layersCubeList = UIToolkit.sortLayerCubeByLogic(layersCubeList);
    layersCube = layersCubeList.map((cubeId: CubeId): FreeObjMap => {
        return {
            id: cubeId
        };
    });
    group.push(layersCube);

    // 层板, 按top降序排列，越靠近货架底部，越排前面，todo：横向排序
    layers = Utils.quickSortByKey(layers, 'top').reverse();
    group.push(layers);

    // 货架
    shelfs = Utils.quickSortByKey(shelfs, 'left');
    group.push(shelfs);

    temp = Utils.expandArray(group);
    result = temp.map((pos: FreeObjMap): CubeId => {
        return pos.id;
    });

    return result;
}

export {
    sortCopyList
};
